import React from "react";

const QuranPageHeader = ({
  showNavigation,
  uiLabels,
  canNext,
  canPrev,
  loading,
  onGoNextPage,
  onGoPrevPage,
  surahLabel,
  juzLabel,
}) => (
  <div className={`quran-page-head ${showNavigation ? "quran-page-head--with-nav" : ""}`.trim()} dir="ltr">
    {showNavigation && (
      <button
        type="button"
        className="quran-icon-btn quran-head-nav-btn"
        aria-label={uiLabels.nextPage}
        title={uiLabels.nextPage}
        disabled={!canNext || loading}
        onClick={onGoNextPage}
      >
        &lt;
      </button>
    )}

    <div className="quran-head-item quran-head-left" dir="rtl">{surahLabel}</div>
    <div className="quran-head-item quran-head-right" dir="rtl">{uiLabels.juz} {juzLabel}</div>

    {showNavigation && (
      <button
        type="button"
        className="quran-icon-btn quran-head-nav-btn"
        aria-label={uiLabels.prevPage}
        title={uiLabels.prevPage}
        disabled={!canPrev || loading}
        onClick={onGoPrevPage}
      >
        &gt;
      </button>
    )}
  </div>
);

export default QuranPageHeader;